export default __webpack_public_path__ + "static/media/records.5278e8e6.jpg";